import React, { useEffect, useMemo, useState } from "react";
import {
    CCard,
    CCardBody,
    CFormInput,
    CButton,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CInputGroup,
    CInputGroupText,
    CFormSelect,
    CCol,
    CBadge
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilSearch, cilPlus, cilX, cilPencil, cilTrash, cilSave } from '@coreui/icons';
import { STRING } from "utils/String";
import productService from "services/productService";
import { imageUrl } from "utils/helper";
import { useLocation, useParams } from "react-router";
import layerServices from "services/layerServices";
import { showSuccessAlert } from "utils/swalAlert";
import addIcon from '../../assets/add-product.png'
import { showErrorAlert } from "utils/swalAlert";





const SingleLayers = () => {
    const data = useLocation();
    const layer = data?.state?.layer;
    const params = useParams()
    console.log(layer)

    const fieldConfig = {
        costPrice: { label: "Cost Price", type: "number", placeholder: "Enter cost price" },
        retailPrice: { label: "Retail Price", type: "number", placeholder: "Enter retail price" },
        discountPrice: { label: "Discount %", type: "number", placeholder: "Discount price" },
        goodLaneCapacity: { label: "Goods Lane Capacity", type: "number", placeholder: "Enter capacity", disable: true },
        currentStock: { label: "Current Stock", type: "number", placeholder: "Enter stock quantity", maxValue: layer?.capacity },
        inventryWarningValue: { label: "Inventory Warning Value", type: "number", placeholder: "Set warning threshold" },
        productionDate: { label: "Production Date", type: "date", placeholder: "Select production date" },
        validityPeriod: { label: "Validity Period (Days)", type: "number", placeholder: "Enter days" },
        validityWarningValue: { label: "Validity Warning Value", type: "number", placeholder: "Set warning days" },
    };

    const createEmptySlot = (layerCapacity = "") => ({
        product: null,
        ...Object.keys(fieldConfig).reduce((acc, key) => {
            acc[key] = key === "goodLaneCapacity" ? layerCapacity : "";
            return acc;
        }, {}),
    });


    const [numberOfSlots, setNumberOfSlots] = useState(layer?.coils || 10);
    const [slotsData, setSlotsData] = useState(
        Array.from({ length: layer?.coils || 10 }, () => createEmptySlot(layer?.capacity || ""))
    );


    useEffect(() => {
        if (layer) {
            setNumberOfSlots(layer.coils);
            setSlotsData(
                Array.from({ length: layer?.coils || 10 }, () => createEmptySlot(layer?.capacity || ""))
            )
        }
    }, [layer]);



    //   @Api services 
    const { getProducts, getCategory } = productService()
    const { assignProducts, getLayerService } = layerServices()

    const [categories, setCategories] = useState([])
    const [products, setProducts] = useState([])
    const [selectedCategoryId, setSelectedCategoryId] = useState("")
    const [loadingProducts, setLoadingProducts] = useState(false)

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeLayerIndex, setActiveLayerIndex] = useState(null);
    const [search, setSearch] = useState("");
    const [saving, setSaving] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        getLayerService({
            layerId: params.layerId,
            machineId: params.machineId
        }).then((res) => {
            console.log(res);
            if (res?.success && res?.data?.slots && res.data.slots.length > 0) {
                // Convert backend slots to frontend format
                const backendSlots = res.data.slots.map(slot => ({
                    product: slot.productId,
                    costPrice: slot.costPrice || "",
                    retailPrice: slot.retailPrice || "",
                    goodLaneCapacity: slot.goodLaneCapacity || layer?.capacity || "",
                    currentStock: slot.currentStock || "",
                    inventryWarningValue: slot.inventryWarningValue || "",
                    productionDate: slot.productionDate?.split("T")[0] || "",
                    validityPeriod: slot.validityPeriod || "",
                    validityWarningValue: slot.validityWarningValue || "",
                    discountPrice: slot.discountPrice || "",
                    categoryId: slot?.categoryId || slot?.productId?.categoryId || ""
                }));
                console.log(backendSlots)
                setSlotsData(backendSlots);
                setNumberOfSlots(backendSlots.length);
            } else if (layer) {
                // If no slots data, create empty slots with layer capacity
                const emptySlots = Array.from({ length: layer.coils }, () => createEmptySlot(layer.capacity));
                setSlotsData(emptySlots);
                setNumberOfSlots(layer.coils);
            }
        }).catch(err => console.log(err))
    }, [])

    const handleSave = async () => {
        // Validation: Check if slots with products have all required fields
        const slotsWithProducts = slotsData.filter(slot => slot.product);
        const errors = {};
        
        if (slotsWithProducts.length > 0) {
            const requiredFields = ['costPrice', 'retailPrice', 'currentStock', 'inventryWarningValue', 'productionDate', 'validityPeriod', 'validityWarningValue'];
            
            for (let i = 0; i < slotsData.length; i++) {
                const slot = slotsData[i];
                if (slot.product) {
                    const missingFields = requiredFields.filter(field => !slot[field] || slot[field] === '');
                    
                    if (missingFields.length > 0) {
                        errors[i] = missingFields;
                    }
                }
            }
        }

        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            return;
        }

        setValidationErrors({});
        setSaving(true);
        try {
            const payload = slotsData.map(({ product, ...rest }) => {
                return {
                    ...rest,
                    productId: product?._id || null,
                    categoryId: product?.categoryId?._id || product?.categoryId || null,
                    goodLaneCapacity: layer?.capacity
                }
            })

            const res = await assignProducts({
                layerId: params.layerId,
                machineId: params.machineId
            }, payload)
            console.log(res)
            showSuccessAlert("Data saved successfully!")

        } catch (error) {
            console.error('Save failed:', error);
            alert('Failed to save data');
        } finally {
            setSaving(false);
        }
    };

            useEffect(() => {
                getCategory().then((res) => {
                    if (res.success) {
                        const data = res.data.data
                        if (data.length) {
                            setCategories(data.map((item) => ({
                                label: item.name,
                                value: item._id
                            })))
                        }
                    }
                }).catch(err => console.log(err))
                // getProducts()
            }, [])

    const filteredProducts = useMemo(() => {
        const q = search.trim().toLowerCase();
        const list = products || [];
        if (!q) return list;
        return list.filter(
            (p) =>
                (p?.name || "").toLowerCase().includes(q) ||
                (p?.sku || "").toLowerCase().includes(q) ||
                (p?.category?.name || p?.category || "").toLowerCase().includes(q)
        );
    }, [search, products]);

    const handleSlotChange = (count) => {
        const newCount = Math.min(Math.max(1, count), 10);
        setNumberOfSlots(newCount);
        setSlotsData((prev) =>
            Array.from({ length: newCount }, (_, i) => prev[i] || createEmptySlot(layer?.capacity || ""))
        );
    };

    const handleInputChange = (index, field, value) => {
        setSlotsData((prev) => {
            const updated = [...prev];
            const capacity = layer.capacity;

            // Validate currentStock doesn't exceed goodLaneCapacity
            if (field === 'currentStock') {
                const stock = parseInt(value) || 0;
                if (stock > capacity && capacity > 0) {
                    return prev;
                }
            }

            // Validate inventryWarningValue doesn't exceed goodLaneCapacity
            if (field === 'inventryWarningValue') {
                const warningValue = parseInt(value) || 0;
                if (warningValue > capacity && capacity > 0) {
                    return prev;
                }
            }

            // Calculate retail price when discount percentage changes
            if (field === 'discountPrice') {
                const costPrice = parseFloat(updated[index].costPrice) || 0;
                const discountPrice = parseFloat(value) || 0;
                const retailPrice = costPrice - (costPrice * discountPrice / 100);
                updated[index] = { 
                    ...updated[index], 
                    [field]: value,
                    retailPrice: retailPrice.toFixed(2)
                };
                return updated;
            }

            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
        
        // Clear validation error for this field
        if (validationErrors[index]?.includes(field)) {
            setValidationErrors(prev => {
                const updated = { ...prev };
                updated[index] = updated[index].filter(f => f !== field);
                if (updated[index].length === 0) delete updated[index];
                return updated;
            });
        }
    };

    const openProductModal = (layerIndex) => {
        setActiveLayerIndex(layerIndex);
        setSearch("");
        setProducts([]);
        setSelectedCategoryId("");
        setIsModalOpen(true);
    };

    const selectProduct = (product) => {
        // Check if product already exists in other slots
        const isDuplicate = slotsData.some((slot, idx) => 
            idx !== activeLayerIndex && slot.product?._id === product._id
        );
            
        if (isDuplicate) {
            showErrorAlert('This product is already assigned to another slot!');
            return;
        }

        setSlotsData((prev) => {
            const updated = [...prev];
            updated[activeLayerIndex] = {
                ...updated[activeLayerIndex],
                product,
                costPrice: product.basePrice || "",
                retailPrice: product.finalPrice || "",
            };
            return updated;
        });
        setIsModalOpen(false);
        setActiveLayerIndex(null);
    };

    const clearProduct = (layerIndex) => {
        // console.log(slotsData)
        // return
        setSlotsData((prev) => {
            const updated = [...prev];
            updated[layerIndex] = {
                ...updated[layerIndex], product: null,
                costPrice: "",
                currentStock: "",
                inventryWarningValue: "",
                productionDate: "",
                retailPrice: "",
                validityPeriod: "",
                validityWarningValue: ""
            };
            return updated;
        });
    };
    const handleCategoryChange = async (categoryId) => {
        console.log(categoryId)
        const category = categories.find((c) => c.value == categoryId)
        console.log(category)
        setSelectedCategoryId(categoryId);
        setProducts([]);
        if (!categoryId) return;
        setLoadingProducts(true);
        try {
            const res = await getProducts({ category: category?.label });
            if (res?.success) {
                setProducts(res?.data?.data || []);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoadingProducts(false);
        }
    };

    return (
        <div
            style={{
                padding: "10px",
                minHeight: "100vh",
                // backgroundColor: "#006ad3ff",
                width: "100vw",
                boxSizing: "border-box",
                overflow: "auto"

            }}
        >
            <CCard className="mb-4">
                <CCardBody style={{
                    overflow: "scroll",
                    maxWidth: "83%"
                }}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">Layer {layer.id} Configuration</h5>
                        <CButton
                            color="primary"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            <CIcon icon={cilSave} className="me-1" />
                            {saving ? 'Saving...' : 'Save'}
                        </CButton>
                    </div>
                    <div className="d-flex gap-4 align-items-start">


                        {/* Layers Table */}
                        <div className="flex-grow-1 ">
                            <div className="table-responsive">
                                <table className="table table-bordered align-middle mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ width: "180px" }}>Field</th>
                                            {slotsData.map((slot, index) => (
                                                <th key={index}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span className="fw-semibold">{STRING.layer} {index + 1}</span>
                                                        <span className={`small ${slot.product ? 'text-success' : 'text-danger'}`}>
                                                            {slot.product ? '✓' : '✗'}
                                                        </span>
                                                    </div>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="fw-semibold">Product</td>
                                            {slotsData.map((slot, index) => (
                                                <td key={`product-${index}`} style={{ height: "80px", width: "120px", textAlign: "center", verticalAlign: "middle" }}>
                                                    {slot.product ? (
                                                        <div className="d-flex flex-column gap-2">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <div
                                                                    style={{
                                                                        width: "48px",
                                                                        height: "48px",
                                                                        borderRadius: "4px",
                                                                        overflow: "hidden",
                                                                        background: "#eef2f7",
                                                                        flexShrink: 0
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={imageUrl(slot.product.image)}
                                                                        alt={slot.product.name}
                                                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                    />
                                                                </div>
                                                                <small className="text-muted text-truncate" title={slot.product.name}>
                                                                    {slot.product.name}
                                                                </small>
                                                            </div>
                                                            <div className="d-flex gap-2">
                                                                <CButton
                                                                    color="outline-primary"
                                                                    size="sm"
                                                                    onClick={() => openProductModal(index)}
                                                                >
                                                                    <CIcon icon={cilPencil} />
                                                                </CButton>
                                                                <CButton
                                                                    color="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => clearProduct(index)}
                                                                >
                                                                    <CIcon icon={cilTrash} />
                                                                </CButton>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            onClick={() => openProductModal(index)}
                                                            style={{ cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}
                                                        >
                                                            <img
                                                                src={addIcon}
                                                                alt="Add Product"
                                                                style={{ width: "48px", height: "48px", objectFit: "cover" }}
                                                            />
                                                        </div>
                                                    )}
                                                </td>
                                            ))}
                                        </tr>

                                        {Object.entries(fieldConfig).map(([key, config]) => {
                                            console.log(config)

                                            return (
                                                <tr key={key}>
                                                    <td className="fw-semibold">{config.label}</td>
                                                    {slotsData.map((slot, index) => (
                                                        <td key={`${index}-${key}`}>
                                                            <CFormInput
                                                                type={config.type}
                                                                id={`${index}-${key}`}
                                                                value={slot[key]}
                                                                onChange={(e) => handleInputChange(index, key, e.target.value)}
                                                                placeholder={config.placeholder}
                                                                size="sm"
                                                                disabled={config.disable ? config.disable : false}
                                                                style={{
                                                                    borderColor: validationErrors[index]?.includes(key) ? '#dc3545' : '',
                                                                    borderWidth: validationErrors[index]?.includes(key) ? '2px' : '1px'
                                                                }}
                                                            />
                                                        </td>
                                                    ))}
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </CCardBody>
            </CCard>

            {/* Product Selection Modal */}
            <CModal
                visible={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                size="lg"
            >
                <CModalHeader>
                    <CModalTitle>
                        Select Product for Layer {activeLayerIndex !== null ? activeLayerIndex + 1 : ''}
                    </CModalTitle>
                    <CButton color="transparent" onClick={() => setIsModalOpen(false)}>
                        <CIcon icon={cilX} />
                    </CButton>
                </CModalHeader>
                <CModalBody>
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Select Category</label>
                        <CFormSelect
                            value={selectedCategoryId}
                            onChange={(e) => handleCategoryChange(e.target.value)}
                        >
                            <option value="">Choose category...</option>
                            {categories.map((cat) => (
                                <option key={cat.value} value={cat.value}>
                                    {cat.label}
                                </option>
                            ))}
                        </CFormSelect>
                    </div>
                    <CInputGroup className="mb-3">
                        <CInputGroupText>
                            <CIcon icon={cilSearch} />
                        </CInputGroupText>
                        <CFormInput
                            placeholder="Search by name, SKU or category..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            disabled={!selectedCategoryId}
                        />
                    </CInputGroup>

                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                        {!selectedCategoryId ? (
                            <div className="text-center py-5">
                                <h6 className="mb-2">Select a category to load products</h6>
                                <p className="text-muted mb-0">Products will show here after category selection.</p>
                            </div>
                        ) : loadingProducts ? (
                            <div className="text-center py-5">
                                <h6 className="mb-2">Loading products...</h6>
                            </div>
                        ) : filteredProducts.length === 0 ? (
                            <div className="text-center py-5">
                                <div className="display-1 text-muted mb-3">📦</div>
                                <h5>No products found</h5>
                                <p className="text-muted">Try different search terms</p>
                            </div>
                        ) : (
                            <div className="row g-3">
                                {filteredProducts.map((p) => (
                                    <CCol md={4} key={p.id || p._id}>
                                        <div
                                            className="card h-100 border cursor-pointer"
                                            onClick={() => selectProduct(p)}
                                            style={{
                                                transition: "transform 0.15s ease, box-shadow 0.15s ease",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                                borderRadius: "8px"
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = "translateY(-2px)";
                                                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.12)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = "translateY(0)";
                                                e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.05)";
                                            }}
                                        >
                                            <div className="card-body p-2">
                                                <div className="d-flex align-items-center gap-2">
                                                    <div
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                            borderRadius: "6px",
                                                            overflow: "hidden",
                                                            background: "#f8fafc",
                                                            flexShrink: 0
                                                        }}
                                                    >
                                                        <img
                                                            src={imageUrl(p.image)}
                                                            alt={p.name}
                                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                        />
                                                    </div>
                                                    <div className="flex-grow-1 min-w-0">
                                                        <h6 className="card-title mb-1 text-truncate" style={{ fontSize: "0.9rem" }} title={p.name}>
                                                            {p.name}
                                                        </h6>
                                                        <div className="d-flex align-items-center gap-1 mb-1">
                                                            <span className="fw-bold text-primary" style={{ fontSize: "0.85rem" }}>LRD{p.finalPrice}</span>
                                                            <CBadge color="info" shape="rounded-pill" style={{ fontSize: "0.7rem" }}>
                                                                {p?.categoryId?.name || "Category"}
                                                            </CBadge>
                                                        </div>
                                                        <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                                                            {p.sku ? `SKU: ${p.sku}` : " "}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CCol>
                                ))}
                            </div>
                        )}
                    </div>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={() => setIsModalOpen(false)}>
                        Cancel
                    </CButton>
                </CModalFooter>
            </CModal>

        </div>
    );
};

export default SingleLayers;
